import { Typography } from "@material-ui/core";
import * as React from "react";
import classNames from "classnames";

function getSpecialFieldSelectDisplay(classes, label: string): any {
    return <Typography className={classNames(classes.specialFieldDisplay)}>{label}</Typography>;
}

export default getSpecialFieldSelectDisplay;
